export default __webpack_public_path__ + "static/media/ParsingLogs.6c1dce60.md";